<template>
    <div>
        <div class="card dashcard mb-0">

            <div class="card-body">

                <div class="form-row">
                    <div class="col col-12 col-md-3">
                        <div class="input-group mb-1">
                        <div class="input-group-prepend">
                            <button type="button" class="btn btn-outline-primary" @click="load(false)" :disabled="$store.state.loading" id="refresh-button">
                                <i class="fas fa-sync-alt fa-fw"></i>
                            </button>
                        </div>
                        <input type="date" class="form form-control" v-model="referencia" :disabled="leitura_amostras" id="ref-data" />
                        </div>
                    </div>

                    <div class="col col-12 col-md-3" v-if="locais && locais.length">
                        <az-input
                            icon="fa-solid fa-car-side fa-fw"
                            placeholder="Todos..."
                            type="select"
                            :optionsList="locais" 
                            optionsData="id_local" 
                            v-model="id_local" />
                    </div>

                    <div class="col col-12 col-md-3" v-if="leitura_amostras">
                        <az-input
                            icon="fa-solid fa-location-dot fa-fw"
                            placeholder="Selecione o Status..."
                            type="select"
                            optionsMode="aql"
                            optionsName="amostra-rastro-status-coleta"
                            service="amostra_rastro_status.index"
                            optionsData="id_amostra_rastro_status"
                            :optionsParm="{ coleta: true }"
                            required
                            :validate="validate"
                            v-model="id_amostra_rastro_status" />
                    </div>

                    <div class="col col-12" :class=" ( locais && locais.length ) ? ( leitura_amostras ? 'col-md-3' : 'col-md-6' ) : ( leitura_amostras ? 'col-md-6' : 'col-md-9' )">
                        <az-input  
                            ref="pesq"
                            :icon="leitura_amostras ? '' : 'fas fa-search fa-fw'"
                            :placeholder="leitura_amostras ? 'Ler Amostra...' : 'Pesquisar...'"
                            v-model="search"
                            @onEnter="ler()">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend" v-if="leitura_amostras">
                                    <button class="btn btn-outline-secondary" @click.prevent="leitura_barcode = !leitura_barcode">
                                        <i class="fa-solid fa-barcode fa-fw" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </template>
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <template v-if="leitura_amostras">
                                        <div class="input-group-append" v-if="ident_user">
                                            <span class="input-group-text" id="basic-addon2">{{ ident_user.login }}</span>
                                        </div>
                                        <button type="button" class="btn btn-outline-dark" @click="toggle_barcode()" :disabled="$store.state.loading" title="Encerrar Leitura Amostras">
                                            <i class="fa fa-times fa-fw" aria-hidden="true"></i>
                                        </button>    
                                    </template>

                                    <template v-else>
                                        <button type="button" class="btn btn-outline-dark" @click="toggle_barcode()" :disabled="$store.state.loading" title="Ler Amostras">
                                            <i class="fa-solid fa-barcode fa-fw"></i>
                                        </button>

                                        <button type="button" class="btn btn-outline-dark" @click="$refs.atendoutros.coleta_abrir(referencia, id_recepcao)" :disabled="$store.state.loading" title="Outros Atendimentos">
                                            <i class="fa-solid fa-users-line fa-fw"></i>
                                        </button>
                                        
                                        <button type="button" class="btn btn-outline-primary" @click="entregar ()" :disabled="$store.state.loading" id="entregar-button" title="Identificar Atendimento">
                                            <i class="fa-solid fa-hand-holding-droplet fa-fw"></i>
                                        </button>
                                    </template>
                                </div>
                            </template>
                        </az-input>
                    </div>
                </div>

            </div>

        </div>

        <div class="progress mt-1 mb-3">
            <div class="indeterminate" v-if="$store.state.loading && exibicao"></div>
            <div class="determinate" v-else></div>
        </div>

        <template v-if="leitura_amostras">

            <div v-if="leitura_barcode">

                <div id="qr-code-full-region"></div>

                <qrcode-scanner
                    :qrbox="250" 
                    :fps="10" 
                    style="width: 300px;"
                    @result="onScan"
                />

                <video id="beepElementId" src="/store-scanner-beep-90395.mp3" playsinline preload="auto" style="height: 10px;"></video> 

            </div>

            <div v-if="lista_amostras && lista_amostras.length">
                <lista-amostras :lista="lista_amostras" @editar="verAtendimento" />
            </div>

            <az-empty-state icon="fa-solid fa-barcode" msg="Nenhum amostra identificada." v-else />

        </template>

        <template v-else>

            <div v-if="( !exibicao || !exibicao.length ) && ( !outros || !outros.length )">
                <az-empty-state icon="fas fa-vials" msg="Nenhum atendimento identificado para coleta." />
            </div>

            <template v-else>

                <outros-chamada :outros="outros" :na_coleta="true" :search="search" @refresh="load()" :agora="agora">
                    <template v-slot:acao-paciente="slotProps">
                        <div class="d-flex" v-if="slotProps && slotProps.outro && slotProps.outro.id_atendimento">
                            <button type="button" class="btn btn-sm btn-outline-primary" @click="verAtendimento (slotProps.outro)" :disabled="$store.state.loading" id="entregar-button">
                                <i class="fa-solid fa-vials fa-fw mr-2"></i> Amostras
                            </button>

                            <!-- Menu de opções -->
                            <div class="dropleft d-flex align-items-center justify-content-center ml-3">
                                <a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i class="fas fa-ellipsis-v"></i>
                                </a>
                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <button class="dropdown-item" @click="novoDocumento(slotProps.outro.marcacao ? slotProps.outro.marcacao : slotProps.outro)">
                                        Emitir Documento
                                    </button>
                                </div>
                            </div>
                        </div>

                        <button type="button" class="btn btn-sm btn-outline-primary" @click="entregar (slotProps.outro.paciente, slotProps.outro)" :disabled="$store.state.loading" id="entregar-button" v-else-if="slotProps && slotProps.outro">
                            <i class="fa-solid fa-hand-holding-droplet fa-fw"></i>
                        </button>
                    </template>
                </outros-chamada>

                <div v-for="(itens, grupo, igx) in lista_agrupada" :key="igx">
                            
                    <h5 v-if="grupo">
                        <a href="#" @click.prevent="toggle_retracao(grupo)">
                            <i class="far fa-minus-square mr-2" v-if="!retracao[grupo]"></i>
                            <i class="far fa-plus-square mr-2" v-else></i>
                        </a>
                        {{ grupo }}
                        <span class="badge badge-secondary ml-2">
                            {{ itens.length }}
                        </span>
                    </h5>

                    <template v-if="!retracao[grupo]">

                        <div class="mb-3 mx-3">
                            <div class="row my-2 py-1 dashcard bg-white align-items-center" class2="w3-animate-opacity" v-for="(item, index) in itens" :key="index">
                                <!-- Ação -->
                                <div class="col-12 col-md-2 col-lg-2 d-flex flex-column mt-md-0 mt-3">
                                    <button type="button" class="btn btn-sm" 
                                        :class="'btn-' + ( ( item.item_status.acao_id == 'ematd' || ( item.item_status.acao_id == 'pausa' && ( !item.item_status.dt_timer || item.item_status.dt_timer > agora ) ) ) ? 'outline-' : '' )
                                        + item.item_status.cor" v-if="item.item_status" 
                                        :disabled="( !item.item_status.acao && item.item_status.valor != 'nao-compareceu' ) || $store.state.loading" 
                                        @click="executar_acao(item)">
                                        <i :class="item.item_status.acao_id == 'ch' ? item.item_status.icon_acao : item.item_status.icon" aria-hidden="true" v-if="item.item_status && item.item_status.icon" class="mr-2"></i>
                                        <span v-if="( item.item_status.acao_id == 'pausa' && item.item_status.dt_timer && item.item_status.dt_timer < agora )">
                                            Chamar Novamente
                                        </span>
                                        <span v-else>
                                            {{ item.item_status.acao ? item.item_status.acao : item.item_status.quebra }}
                                        </span>
                                    </button>

                                    <div class="small text-muted text-center" v-if="item 
                                        && item.atendimento && agora
                                        && item.atendimento.dt_inicio.substr(0,10) == $util.hoje() 
                                        && item.item_status.acao == 'Chamar'">

                                        <span v-if="te_max && te_max < duracao(hora_inicio_espera(item), false)" class="badge badge-danger">
                                            Esperando {{ duracao(hora_inicio_espera(item)) }}...
                                        </span>

                                        <span v-else class="small text-muted">
                                            Esperando {{ duracao(hora_inicio_espera(item)) }}...
                                        </span>

                                    </div>

                                    <div class="small text-muted text-center" v-else-if="item 
                                        && item.atendimento && agora
                                        && item.item_status.dt_timer                                   
                                        && item.item_status.dt_timer.substr(0,10) == $util.hoje()">

                                        <span v-if="item.item_status.dt_timer > agora">Em {{ tempo(item) }}...</span>

                                        <span v-else>
                                            Há {{ tempo(item) }}...
                                        </span>
                                    </div>

                                    <div v-else>
                                        <div class="progress mt-1" v-if="item.atendimento && item.atendimento.amostras && item.atendimento.amostras.length">
                                            <div class="progress-bar" role="progressbar" 
                                                :class="status == 'R' ? 'bg-success' : 'bg-warning'"
                                                :style="'width: ' + Math.round( ( lista.length / item.atendimento.amostras.length ) * 100 ) + '%'" aria-valuenow="15" aria-valuemin="0" 
                                                aria-valuemax="100" v-for="(lista, status, isx) in lista_status(item)" :key="isx">
                                            </div>
                                        </div>

                                        <div class="text-center text-muted small" v-if="( item.item_status.acao_id == 'ematd' || item.item_status.acao_id == 'chd' ) && item.atendimento && item.atendimento.progresso_atendimento && item.atendimento.progresso_atendimento.usuario">
                                            Por: {{ item.atendimento.progresso_atendimento.usuario.st_login }}
                                        </div>
                                    </div>
                                </div>
                            
                                <!-- Hora da Marcação -->
                                <div class="col col-12 col-md-2 d-flex justify-content-center justify-content-md-start">
                                    <celula-horarios-marcacao :hor="{ marcacao: item }" />
                                </div>

                                <!-- Identificação do Paciente -->
                                <div class="col col-12 col-md-4">
                                    <celula-dados-paciente :coleta="true" :hor="{ marcacao: item }" :callback_paciente="set_nome_search" />
                                </div>

                                <!-- Dados dos Procedimentos -->
                                <div class="col col-12 col-md-4 d-flex justify-content-between">

                                    <celula-dados-procedimento :hor="{ marcacao: item }" :lab="true" 
                                        @abriranexos="abrir_anexar_arquivo" @abrirpreatend="$refs.doc_pre_atend.abrir"
                                        :callback_filtrar="filtrar" />

                                    <!-- Menu de opções -->
                                    <div class="dropleft d-flex align-items-center justify-content-center order-1 order-md-2">
                                        <a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <i class="fas fa-ellipsis-v"></i>
                                        </a>
                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                            <button class="dropdown-item" @click="verColeta(item)">
                                                Amostras
                                            </button>
                                            <button class="dropdown-item" @click="$refs.doc_pre_atend.abrir(item)">
                                                Pré-Atendimento
                                                <span class="badge badge-secondary" v-if="item.doc_pre_atends_count || ( item.doc_pre_atends && item.doc_pre_atends.length )">
                                                    {{ item.doc_pre_atends_count ? item.doc_pre_atends_count : item.doc_pre_atends.length }}
                                                </span>
                                            </button>
                                            <button class="dropdown-item" @click="novoDocumento(item)">
                                                Emitir Documento
                                            </button>

                                            <button class="dropdown-item" @click="alterar_data_entrega(item)" :disabled="!( item && item.id_atendimento && item.ch_estado_marcacao == 'A' )">
                                                Alterar Data de Entrega
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </template>

                </div>

            </template>

        </template>

        <pre v-if="false">{{ dados }}</pre>

        <!-- Coleta Modal -->
        <div class="modal fade" id="coletaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="edicao">
                    <div class="modal-header">
                        <h5 class="modal-title">Coleta de Material</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="card-deck">
                            <div class="card">
                                <div class="card-body">
                                    <!-- Identificação do Paciente -->
                                    <celula-dados-paciente :hor="{ marcacao: edicao }" />
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-body">
                                    <!-- Dados dos Procedimentos -->
                                    <celula-dados-procedimento :hor="{ marcacao: edicao }" :lab="true" />
                                </div>
                            </div>
                        </div>

                        <div class="alert bg-dark text-white text-center mt-3 lead">
                            {{ edicao.item_status.ultima_etapa.st_etapa_atendimento }}
                        </div>

                        <div class="d-flex flex-column mb-3" v-if="edicao.item_status.ultima_etapa.id_etapa_atendimento == 5">
                            <div class="form-row">
                                <div class="col col-12 col-md-4 d-flex flex-column">
                                    <button 
                                        id="pep-chamar-novamente"
                                        type="button"
                                        class="btn btn-outline-danger"
                                        :disabled="rechamado"
                                        @click="chamar(item, true)">
                                        <i class="fas fa-bell mr-2" v-if="!$store.state.loading"></i>
                                        <div class="spinner-border spinner-border-sm" role="status" v-else>
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                        Chamar Novamente
                                    </button>
                                </div>
                                <div class="col col-12 col-md-4 d-flex flex-column">
                                    <button 
                                        type="button"
                                        class="btn btn-outline-success"
                                        id="pep-iniciar-atendimento"
                                        @click="iniciarAtendimento(item)">
                                        <i class="fas fa-play mr-2" v-if="!$store.state.loading"></i>
                                        <div class="spinner-border spinner-border-sm" role="status" v-else>
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                        Iniciar Atendimento
                                    </button>
                                </div>
                                <div class="col col-12 col-md-4 d-flex flex-column">
                                    <button 
                                        type="button"
                                        class="btn btn-outline-secondary"
                                        id="pep-nao-iniciar-atendimento"
                                        @click="naoComparecer(item)">
                                        <i class="fas fa-times mr-2" v-if="!$store.state.loading"></i>
                                        <div class="spinner-border spinner-border-sm" role="status" v-else>
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                        Paciente não compareceu
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <button type="button" class="btn btn-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Iniciar Atendimento -->
        <div class="modal fade" id="iniciarAtendimentoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="edicao">
                    <div class="modal-header">
                        <h5 class="modal-title">Coleta</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <pre>{{ edicao }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>

        <amostras ref="amostras" :coleta="true" @chamar="chamar_novamente" @refresh="load" />
        <documento-pre-atendimento ref="doc_pre_atend" />
        
        <!-- Envio de Arquivo -->
        <template v-if="acao_anexar">
            <az-file-upload
                ref="upload"
                @refresh="carregar_arquivos()"
                :multiple="true"
                :arquivos="marcacao.arquivos"
                :parms="{ model_type: 'marcacao', model_id: marcacao.id_marcacao, id_paciente: marcacao.id_paciente }" />
        </template>

        <!-- Modal Entrega de Material -->
        <div class="modal fade" id="entregaMaterialModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Entregar Material</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-row">
                            <div class="col col-12 col-md-9">
                                <az-input 
                                    placeholder="Selecionar paciente..."
                                    icon="fas fa-user"
                                    type="autocomplete" 
                                    optionsMode="aql"
                                    service="pacientes.index"
                                    optionsDisplay="search"
                                    ref="info_paciente"
                                    v-model="paciente" 
                                    :optimized_ac="true"
                                    @selecionado="buscar_atendimentos(apenas_pendentes)">
                                </az-input> 
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input   
                                    type="checkbox-group"
                                    label="Apenas Pendentes"
                                    v-model="apenas_pendentes"
                                    @input="buscar_atendimentos(apenas_pendentes)" />
                            </div>
                        </div>

                        <div class="mt-3">
                            <div v-if="lista_entrega.length">
                                <ul class="list-group">
                                    <li class="list-group-item" v-for="(atd, iax) in lista_entrega" :key="iax">
                                        <div class="form-row">
                                            <div class="col col-12 col-md-3">
                                                <div>
                                                    <a href="#" @click.prevent="verColeta(atd, outro_selecionado)" class="card-link h5">
                                                        #{{ atd.id_atendimento }}
                                                    </a>
                                                </div>
                                                <div>{{ $util.getFormatDate(atd.dt_inicio) }}</div>
                                            </div>
                                            <div class="col col-12 col-md-9">
                                                <celula-dados-procedimento 
                                                    :hor="{ marcacao: atd }" 
                                                    :lab="true" 
                                                    :blockanexos="true"
                                                    :callback_filtrar="filtrar" />
                                            </div>
                                        </div>
                                    </li>
                                </ul>

                                <pre v-if="false">{{ entrega }}</pre>
                            </div>

                            <az-empty-state v-else :msg="!paciente ? 'Selecione o Paciente...' : 'Nenhum atendimento identificado.'" />
                        
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <lista-atend-outros ref="atendoutros" @refresh="load()" @verColeta="verColeta" :coleta="true" />
        <re-identificacao-de-usuario tipo="coleta_material" ref="ident_user" />
        
        <!-- Alterar Prazo de Entrega -->
        <laudos-prazo-entrega ref="prazo_entrega" @refresh="load()" />

        <!-- Documentos -->
        <documento ref="documento" :recepcao="true" />
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import * as moment from 'moment';
import AzInput from '../../shared/forms/AzInput.vue';
import CelulaHorariosMarcacao from '../../shared/table/CelulaHorariosMarcacao.vue';
import CelulaDadosPaciente from '../../shared/table/CelulaDadosPaciente.vue';
import CelulaDadosProcedimento from '../../shared/table/CelulaDadosProcedimento.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import Amostras from './Amostras.vue';
import DocumentoPreAtendimento from '../../shared/DocumentoPreAtendimento.vue';
import AzFileUpload from '../../util/AzFileUpload.vue';
import OutrosChamada from '../../shared/OutrosChamada.vue';
import ListaAtendOutros from '../recepcao/ListaAtendOutros.vue';
import ListaAmostras from './ListaAmostras.vue';
import ReIdentificacaoDeUsuario from '../../shared/ReIdentificacaoDeUsuario.vue';
import Documento from '../consultorio/Documento.vue';
import LaudosPrazoEntrega from '../laudos/LaudosPrazoEntrega.vue';

export default {
    data() { 
        return { 
            dados: null, 
            referencia: this.$util.hoje(), 
            search: "", 
            agora: null,
            edicao: null, 
            rechamado: false, 
            marcacao: null,
            acao_anexar: false,
            outros: [], 
            paciente: "", 
            entrega:  null, 
            locais: [], 
            id_local: "", 
            contexto: null, 
            te_max: null, 
            refresher: null, 
            retracao: [], 
            apenas_pendentes: true, 
            outro_selecionado: null, 
            leitura_amostras: false, 
            leitura_barcode: false, 
            id_amostra_rastro_status: "", 
            lista_amostras: [], 
            validate: false, 
            last_barcode: "", 
            reident_user: false, 
        }
    },

    components: { 
        AzInput,
        CelulaHorariosMarcacao, 
        CelulaDadosPaciente,
        CelulaDadosProcedimento, 
        AzEmptyState,
        Amostras, 
        DocumentoPreAtendimento, 
        AzFileUpload, 
        OutrosChamada, 
        ListaAtendOutros,
        ListaAmostras, 
        ReIdentificacaoDeUsuario, 
        Documento,
        LaudosPrazoEntrega, 
    },

    computed: { 
        id_recepcao: function () { 
            const recep = this.$util.recepcao();

            return recep ? recep.id_recepcao : null;
        },

        lista_entrega: function ()  { 
            if ( !this.entrega || !this.entrega.lista || !this.entrega.lista.length ) { 
                return [];
            }

            return this.entrega.lista; // .filter(item => !this.apenas_pendentes || ( item.atendimento && item.atendimento.atendimento_procedimentos.find(ap => _.get(ap, 'laudo.status_laudo.fl_nao_coletar'))));
        },

        lista_agrupada: function () { 
            return _.groupBy(this.exibicao, 'item_status.quebra');
        },

        OutrasMarcacoesada: function () { 
            return _.groupBy(this.exibicao, 'item_status.quebra');
        },

        exibicao: function () { 
            if ( !this.dados )
                return [];

            let reg = this.$util.getregex(this.search);

            return _.orderBy(
                    _.orderBy(
                        this.dados.lista.filter(item => !this.search || reg.test(JSON.stringify(item)))
                            .map(item => { 
                            if ( item.item_status.acao_id == 'ch' ) { 
                                item.item_status.ordem = 0;
                            } else if ( item.item_status.acao_id == 'chd' ) { 
                                item.item_status.ordem = 0;
                            }

                            return item;
                        }),
                        marcacao => this.hora_inicio_espera(marcacao)
                    ),
                    'item_status.ordem'
                );
        }
    },

    methods: { 
        alterar_data_entrega (marcacao) { 
            console.log('alterar_data_entrega', marcacao);
            this.$refs.prazo_entrega.abrir_marcacao(marcacao.id_marcacao);
        },

        novoDocumento(marcacao) {
          this.$refs.documento.novoDocumento(marcacao);
        },

        onScan (data) { 

            if ( data.text == this.last_barcode ) { 
                return; 
            }

            this.search = data.text;
            this.last_barcode = data.text;

            this.ler()

            setTimeout(() => { 
                this.last_barcode = "";
            }, 2500);

            this.beep();
        },

        ler () { 
            if ( !this.search || !this.leitura_amostras ) { 
                return;
            }

            if ( !this.id_amostra_rastro_status ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: 'Selecione o status de identificação da amostra.',
                    life: 3000
                });

                return;
            }

            this.$util.setCookie('col-idr', this.id_amostra_rastro_status);

            this.$util.atualizar(this, { 
                service: 'amostras', 
                func: 'rastreabilidade', 
                dados: { 
                    codigo: this.search, 
                    id_amostra_rastro_status: this.id_amostra_rastro_status, 
                    ...( this.ident_user ? this.ident_user : {} )
                },
                modal: 'temperaturaModal',
                callback: res => { 

                    let codigo = this.search;

                    this.search = "";

                    if ( !res.lista.length ) { 
                        this.$toast.add({
                            severity: "error",
                            summary: "Atenção",
                            detail: 'Amostra não localizada: ' + codigo,
                            life: 3000
                        });
                    } else { 
                        res.lista.forEach(item => { 
                            this.lista_amostras.unshift(item);
                        });
                    }

                    if ( res.msg ) { 
                        
                        this.$toast.add({
                            severity: "info",
                            summary: "Atenção",
                            detail: res.msg,
                            life: 5000
                        });

                    }

                }
                
            });
        },

        reident(ident, fechar) { 
            if ( ident ) { 
                this.$util.atualizar(this, { 
                    service: 'amostras', 
                    func: 'validar_usuario',
                    dados: ident,
                    callback: () => { 

                        let lista = this.$store.state.contexto['ident_logins']
                            ? this.$store.state.contexto['ident_logins'] 
                            : [];

                        lista.push(ident.login);
                        lista = _.uniq(lista).sort();

                        this.$store.commit('setContexto', { ident_logins: lista });

                        fechar();
                        this.toggle_barcode(ident);

                    }
                });
            }
        }, 

        toggle_barcode (ident = null) { 
            if ( this.reident_user && !this.leitura_amostras ) { 
                if ( ident ) { 
                    this.ident_user = ident;
                } else { 
                    this.$refs.ident_user.abrir(this.reident);
                    return;
                }
            } else { 
                this.ident_user = null;
            }

            if ( !ident ) { 
                ident = {};
            }

            this.validate = false; 
            this.search = "";
            this.leitura_amostras = !this.leitura_amostras;
            this.lista_amostras = [];

            this.$refs.pesq.$refs.input.focus();
        },

        tempo(mrc) {

            if (
                mrc.atendimento &&
                mrc.item_status &&
                mrc.item_status.dt_timer 
            ) {
                let now = moment(this.agora.slice(11,16), "HH:mm:ss");

                let end = moment(
                    mrc.item_status.dt_timer.slice(11, 16),
                    "HH:mm:ss"
                );

                let diff = now > end ? now.diff(end) : end.diff(now);

                let duration = moment.utc(diff).format("HH:mm");

                return duration;
            }
        },
        
        hora_inicio_espera (marcacao) { 
            if ( !marcacao )
                return ''; 

            if ( marcacao.item_status && marcacao.item_status.dt_ultimo ) { 
                return marcacao.item_status.dt_ultimo;
            } else { 
                return marcacao.atendimento ? marcacao.atendimento.dt_inicio : marcacao.dt_inicio;
            }
        },

        toggle_retracao(iq) { 
            this.retracao[iq] = this.retracao[iq] ? false : true;
            this.$util.setCookie('COL-' + iq, this.retracao[iq] ? 1 : 0, 365);
            this.$forceUpdate();
        },

        filtrar (texto) { 
            if ( this.search == '"' + texto + '"' ) { 
                this.search = "";
            } else { 
                this.search = '"' + texto + '"';
            }
        },

        entregar (paciente = null, outro = null) { 
            this.paciente = paciente;
            this.entrega = null; 
            this.outro_selecionado = outro; // _.cloneDeep(outro);
            
            if ( this.paciente ) { 
                this.buscar_atendimentos();
            }

            $('#entregaMaterialModal').modal('show');
        },

        abrir_anexar_arquivo(marcacao) {
            this.marcacao = marcacao;
            this.acao_anexar = true;

            if ( this.marcacao.arquivos && this.marcacao.arquivos.length && !this.marcacao.arquivos.find(arq => arq.arquivo) ) {
                this.carregar_arquivos(true);
                return;
            }

            this.$nextTick(() => {
                this.$refs.upload.abrir();
            });
        },

        carregar_arquivos (abrir = false) {

            this.$store.commit('loading', true);

            this.$util.loadItem(this, {
                service: 'arquivos',
                func: 'links',
                parms: {
                    id: this.marcacao.id_marcacao,
                    type: 'marcacao',
                }
            })
            .then(res => {
                this.marcacao.arquivos = res;

                if ( abrir ) {
                this.$nextTick(() => {
                    this.$refs.upload.abrir();
                });
                }
            })
            .finally(() => {
                this.$store.commit('loading', false);
            });

        },

        lista_status(item) { 
            if ( !item || !item.atendimento || !item.atendimento.amostras )
                return [];

            return _.groupBy(item.atendimento.amostras, 'status_amostra');
        },

        executar_acao (item) { 
            switch (item.item_status.acao_id) {
                case 'ch':
                    this.chamar(item);    
                    break;

                default:
                    this.verColeta(item);
                    break;
            }
        },

        duracao (data, humanize = true) { 
            return humanize
                ? moment
                    .duration(moment(data, "YYYY-MM-DD HH:mm:ss").diff(this.agora))
                    .humanize(true)
                : moment
                    .duration(moment(this.agora, "YYYY-MM-DD HH:mm:ss").diff(data))
                    .asMinutes();
        },

        set_nome_search() { 
            //    
        },

        buscar_atendimentos (apenas_pendentes = false) { 
            if ( !this.paciente ) 
                return;

            this.$util.load(this, { 
                service: 'amostras',
                func: 'coleta',
                parms: { 
                    id_paciente: this.paciente.id_pessoa,
                    apenas_pendentes: apenas_pendentes, 
                },  
                loadTo: res => { 
                    this.entrega = res;
                }
            });
        },

        load() { 
            const uo = this.$util.unidade_operacao();
            const recep = this.$util.recepcao();

            if ( this.refresher ) { 
                clearInterval(this.refresher);
                this.refresher = null;
            }

            let query = { 
                q: [
                    { 
                        name: "amostras.coleta",
                        id: "lista",
                        parms: {
                            referencia: this.referencia,
                            id_unidade_operacao: uo ? uo.id_unidade_operacao : null, 
                            id_recepcao: recep ? recep.id_recepcao : null,  
                            id_local: this.id_local, 
                            te_max: this.te_max,
                            agora: this.agora ? this.agora.slice(11,16) : '', 
                            search: this.search,
                        }
                    },
                    { 
                        name: "atendimento_outros.index",
                        id: "listaoutros",
                        parms: {
                            data: this.referencia,
                            logado: false,
                            coleta: true, 
                            id_unidade_operacao: uo ? uo.id_unidade_operacao : null, 
                            id_recepcao: recep ? recep.id_recepcao : null,  
                        }
                    }
                ]
            };

            this.$store.commit('loading', true);

            this.axios.post('/aql?a=amostras.coleta', query)
                .then(res => { 
                    if ( res.data.lista.status == 200 ) { 
                        this.dados = res.data.lista.data;
                        this.outros = res.data.listaoutros.data;

                        this.locais = _.orderBy(
                            _.uniqBy(
                                this.dados.lista.filter(item => item.local && item.local.fl_coleta_dom)
                                    .map(item => item.local),
                                'id_local'
                            ),
                            'st_local'
                        );
                    }
                })
                .finally(() => {

                    this.$store.commit('loading', false);

                    if ( this.refresher ) { 
                        clearInterval(this.refresher);
                        this.refresher = null;
                    }

                    this.refresher = setInterval(() => {
                        if ( $('.modal').is(':visible') ) { 
                            // 
                        } else if ( !this.$store.state.loading ) { 
                            if ( this.referencia == this.$util.hoje() ) { 
                                this.load(false);
                            }
                        }

                        console.log('Refresh(Coleta)', new Date().toISOString());
                    }, 45000);

                });

            /*
            this.$util.load(this, { 
                service: 'amostras',
                func: 'coleta',
                parms: { 
                    referencia: this.referencia,
                    id_unidade_operacao: uo ? uo.id_unidade_operacao : null, 
                    id_recepcao: recep ? recep.id_recepcao : null,  
                },  
                loadTo: res => { 
                    this.dados = res;
                }
            });
            */
        },

        chamar_novamente(item) { 
            this.chamar(item, true);
        },

        chamar (item, rechamada = false) { 
            this.$store.commit('loading', true);

            let query = { q: 
                [
                    { 
                        name: "atendimentos.chamar",
                        id: "chamada",
                        parms: { 
                            id: item.atendimento.id_atendimento, 
                            id_recepcao: this.$util.getCookie('id_unidade_operacao') ? this.$util.getCookie('id_recepcao') : null,
                            local: this.$util.getCookie('local-chamada'),
                            block_painel: this.$util.getCookie('nao-enviar-painel'), 
                        },
                    }
                ]
            };

            this.axios.post('/aql?a=atendimentos.chamar', query)
                .then(res => { 
                    if ( !res.data )
                        return;

                    if ( res.data.chamada.status == 200 ) { 

                        if ( process.env.VUE_APP_GTAG ) { 

                            let action = 'chamar-coleta';
                            let label = this.$store.state.user.st_login;

                            this.$gtag.event(action, {
                                'event_category': window.redir,
                                'event_label': label,
                                'value': 1
                            });

                        }

                        this.$toast.add({
                            severity: "success",
                            summary: "Amostra",
                            detail: "Chamada realizada.",
                            life: 3000
                        });

                        if ( rechamada ) { 

                            this.rechamado = true;

                        } else { 

                            item.item_status.ultima_etapa = res.data.chamada.data.etapa_atendimento;
                            this.$store.commit('loading', false);

                            this.load();

                            this.verAtendimento (item);

                        }

                    }
                })
                .finally (() => { 
                    this.$store.commit('loading', false);
                });

        },
        
        verAtendimento (item) { 
            this.$refs.amostras.abrir(item.id_atendimento);

            /*
            this.edicao = _.cloneDeep(item);
            this.rechamado = false;

            $('#coletaModal').modal('show');
            */
        },

        verColeta (item, outro = null) { 
            $('.modal').modal('hide');
            
            if ( !item.id_atendimento_outro && ( !item.atendimento || !item.atendimento.amostras.length ) ) { 
                this.verAtendimento(item);
                return;
            }

            this.$refs.amostras.abrir(item.id_atendimento, false, "", outro ? outro.id_atendimento_outro : null);

            if ( outro && outro.id_atendimento_outro && !outro.id_atendimento && item.id_atendimento ) { 
                outro.id_atendimento = item.id_atendimento;
                outro.id_paciente = item.id_paciente;
                outro.paciente = item.paciente;
            }

            //this.edicao = _.cloneDeep(item);

            if ( !item )
                $('#coletaModal').modal('show');
        }

    },

    beforeMount() { 
        this.retracao['Pacientes Atendidos'] = this.$util.getCookie('COL-Pacientes Atendidos') == 1;
    },

    mounted() { 
        this.agora = moment().format("YYYY-MM-DD HH:mm:ss");

        this.te_max = this.$util.getCookie('te-max');

        this.tmaInterval = setInterval(() => {
            this.agora = moment().format("YYYY-MM-DD HH:mm:ss");
        }, 1000 * 20);
        
        this.load();

        this.$store.commit("setBreadcrumb", [
            { name: 'Laboratório', path: "/laboratorio/visao" },
            { name: "Coleta de Material", path: "/laboratorio/coleta-material" }
        ]);

        if ( this.$store.state.user.st_login && this.$store.state.user.st_login.slice(0,6) == 'coleta' ) { 
            this.reident_user = true;
        }

        let id_def = this.$util.getCookie('col-idr');

        if ( id_def ) { 
            this.id_amostra_rastro_status = id_def;
        }
    },

    beforeDestroy () { 
      if ( this.refresher ) { 
          clearInterval(this.refresher);
          this.refresher = null;
      }
    },

}
</script>